import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/useAuth';

/**
 * GoogleCallback
 * Mounted at: /auth/google/success
 *
 * The backend redirects here after Google OAuth succeeds:
 *   /auth/google/success?token=eyJ...
 *
 * This page reads the token, stores it, and redirects to home.
 * Also handles the error case: /auth?error=google_failed
 */
export default function GoogleCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const [status, setStatus] = useState('processing'); // processing | error

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error || !token) {
      setStatus('error');
      setTimeout(() => navigate('/auth?error=google_failed'), 2500);
      return;
    }

    // Store token and log in
    login(token);
    navigate('/home', { replace: true });
  }, []);

  if (status === 'error') {
    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
        style={{ background: 'linear-gradient(135deg, #0a1f15 0%, #0f2d1e 100%)' }}
      >
        <div className="w-16 h-16 rounded-2xl bg-red-500/15 flex items-center justify-center mb-5">
          <i className="ri-error-warning-line text-red-400 text-3xl" />
        </div>
        <p className="text-white font-semibold text-lg mb-2">Google sign-in failed</p>
        <p className="text-white/40 text-sm">Redirecting you back…</p>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{ background: 'linear-gradient(135deg, #0a1f15 0%, #0f2d1e 100%)' }}
    >
      <div
        className="w-16 h-16 rounded-2xl flex items-center justify-center mb-5"
        style={{ background: 'linear-gradient(135deg, #059669, #34d399)', boxShadow: '0 8px 24px rgba(52,211,153,0.3)' }}
      >
        <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" />
      </div>
      <p className="text-white font-semibold text-lg mb-1">Signing you in…</p>
      <p className="text-white/40 text-sm">Just a moment</p>
    </div>
  );
}
